module.exports = __webpack_public_path__ + "static/img/hardware-connection.da79631.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product_images/hardware-connection.jpg
// module id = CLht
// module chunks = 1